'use strict';

var _ = require('lodash');
var ApplicationManagementService = function ApplicationManagementService(ApplicationManagementConstants, featureToggleService) {
  function getEnabled() {
    return _.filter(ApplicationManagementConstants.APPLICATIONS, function (app) {
      return featureToggleService.isEnabled(app);
    });
  }
  function isApplicationEnabled(applicationName) {
    return getEnabled().indexOf(applicationName) !== -1;
  }
  function getEnabledByApplication(array) {
    return _.filter(array, function (element) {
      return isApplicationEnabled(element.application);
    });
  }
  return {
    APPLICATIONS: ApplicationManagementConstants.APPLICATIONS,
    getEnabled: getEnabled,
    isApplicationEnabled: isApplicationEnabled,
    getEnabledByApplication: getEnabledByApplication
  };
};
module.exports = ApplicationManagementService;
ApplicationManagementService.$inject = ['ApplicationManagementConstants', 'FeatureToggleService'];